export const AUTORIZACAO = 'AUTORIZACAO';
export const AUTORIZACAO_START = 'AUTORIZACAO_START';
export const AUTORIZACAO_SUCCESS = 'AUTORIZACAO_SUCCESS';
export const AUTORIZACAO_ERROR = 'AUTORIZACAO_ERROR';

export const AUTORIZACAO_ARQUIVOS = 'AUTORIZACAO_ARQUIVOS';
export const AUTORIZACAO_ARQUIVOS_START = 'AUTORIZACAO_ARQUIVOS_START';
export const AUTORIZACAO_ARQUIVOS_SUCCESS = 'AUTORIZACAO_ARQUIVOS_SUCCESS';
export const AUTORIZACAO_ARQUIVOS_ERROR = 'AUTORIZACAO_ARQUIVOS_ERROR';
